/**
 * Request identity helpers.
 *
 * Historically the app joined everything (request <-> booked slot, drag
 * payloads, Email Sent preservation) on the raw `Timestamp` string — fragile
 * because Sheets can reformat timestamps and two submissions can collide.
 *
 * The durable key is now the `Request ID` column (a UUID assigned at
 * import/clone time, backfilled for old rows by migrateToRequestIds() in
 * apps-script/Code.js). Rows that predate the migration have no ID, so
 * getRequestKey falls back to Timestamp — each row's key is stable for
 * itself either way, because a request booked under its Timestamp keeps
 * using that Timestamp until the migration rewrites both sides together.
 */

export const getRequestKey = (req) => {
  if (!req) return '';
  return req['Request ID'] || req.Timestamp || '';
};

/** Generates a new Request ID. crypto.randomUUID needs a secure context
 * (localhost/https — always true for this app), with a fallback just in case. */
export const newRequestId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `req-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};
